import { useEffect } from "react";
import { eventScroll, winAddEvent, winRemoveEvent, winScrollY } from "@src/utils/dom";
import useBehaviorSubject from "@src/hooks/useBehaviorSubject";
import { pageScrolledSubject } from "@src/store/elements";

export default function PageScrolled() {
  useEffect(() => {
    winAddEvent(eventScroll, onScroll);
    onScroll();
    return () => {
      winRemoveEvent(eventScroll, onScroll);
    };
  }, []);
  return null;
}

function onScroll() {
  if (winScrollY() > 30) {
    winRemoveEvent(eventScroll, onScroll);
    pageScrolledSubject.next(true);
  }
}

export function useScrolled() {
  return useBehaviorSubject(pageScrolledSubject);
}
